import {
  useSideBarStore,
  type Favorite,
} from '@cockpitai/store/navigation/useSideBarStore'
import { urlCipher } from '@cockpitai/utils/urlCipher'
import { useEffect } from 'react'

export function useFavoritesData(data: Favorite[]) {
  const { addFavorite } = useSideBarStore()

  useEffect(() => {
    if (data && data.length > 0) {
      data.forEach((item) => {
        const favorite: Favorite = {
          name: item.name ?? '',
          id: item.id,
          data: item.data ?? '',
          affiliateId: item.affiliateId ?? '',
          occupationType: item.occupationType ?? 0,
          withoutWallet: item.withoutWallet === 'true' ? 'true' : undefined,
        }

        if (item.data || (item.affiliateId && item.occupationType)) {
          favorite.data = item.data
            ? item.data
            : urlCipher(
                `?affiliateId=${item.affiliateId}&occupationType=${item.occupationType}`,
              )
        } else {
          favorite.affiliateId = item.affiliateId

          favorite.occupationType = item.occupationType

          if (item.withoutWallet === 'true') {
            favorite.withoutWallet = 'true'
          }
        }

        addFavorite(favorite)
      })
    }
  }, [data, addFavorite])
}
